import {Component} from '@angular/core';
import {DateHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {HandelsregisterBezeichnungEnumLabels, handelsregisterBezeichnungToTranslationKey, HandelsregistereintragAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-handelsregistereintrag',
  templateUrl: './handelsregistereintrag.component.html'
})
export class HandelsregistereintragComponent extends FormBaseComponent<HandelsregistereintragAngaben> {

  public handelsregisterBezeichnungEnum = HandelsregisterBezeichnungEnumLabels;
  public toTranslationKey = handelsregisterBezeichnungToTranslationKey;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  public onSelectionChange(): void {
    this.form.get('gestelltAm').setValue(null);
    this.form.get('eingetragenAm').setValue(null);
  }

  protected createForm(): void {
    // Legacy-Wert 'GR' aus altem Datenbestand im Backend bereinigen,
    // um Validierungsfehler beim Zurücksenden zu vermeiden.
    if ((this.data.handelsregisterBezeichnung as string) === 'GR') {
      this.data.handelsregisterBezeichnung = null;
    }
    this.form = this.formBuilder.group({
      istErfolgt: [this.data.istErfolgt],
      istBeabsichtigt: [this.data.istBeabsichtigt],
      bereitsGestellt: [this.data.bereitsGestellt],
      ortRegistergericht: [this.data.ortRegistergericht, [
        this.validatorService.required(),
        this.validatorService.maxLength(72)
      ]],
      gestelltAm: [this.data.gestelltAm, [
        this.validatorService.required(),
        this.validatorService.date(),
        this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.gestelltAm),
          this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
      ]],
      eingetragenAm: [this.data.eingetragenAm, [
        this.validatorService.required(),
        this.validatorService.date(),
        this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.eingetragenAm),
          this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
      ]],
      handelsregisterBezeichnung: [this.data.handelsregisterBezeichnung, [
        this.validatorService.required()
      ]],
      handelsregisterNummer: [this.data.handelsregisterNummer, [
        this.validatorService.required(),
        this.validatorService.maxLength(11)
      ]]
    });
  }


}
